import bus from "./bus";

export function selectImage() {
    return new Promise(resolve => {
        bus.emit("select-image");
        bus.on("select-image-result", resolve);
    });
}

export function selectAdminUser() {
    return new Promise(resolve => {
        bus.emit("select-admin-user");
        bus.on("select-admin-user-result", resolve);
    });
}

export function selectGood() {
    return new Promise(resolve => {
        bus.emit("select-good");
        bus.on("select-good-result", resolve);
    });
}